/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterAccountNotificationSetting {
    getFixupPrototypeFunction() { return MasterAccountNotificationSetting.fixupPrototype; }

    static newInstance(model: Partial<MasterAccountNotificationSetting>): MasterAccountNotificationSetting {
        let obj = Object.assign(new MasterAccountNotificationSetting(), model);
        MasterAccountNotificationSetting.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterAccountNotificationSetting>): MasterAccountNotificationSetting {
        if (!model) return null;
        return MasterAccountNotificationSetting.newInstance(<MasterAccountNotificationSetting> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterAccountNotificationSetting) {
        if (!obj) return;

        models.MasterAccountNotificationSetting.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterAccountNotificationSetting): boolean {
        Object.setPrototypeOf(obj, MasterAccountNotificationSetting.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.email_settings) {
            models.MasterAccountEmailSetting.fixupPrototype(this.email_settings);
        }
    }

    /**
     * Organization name
     */
    organization_name: string;

    /**
     * Support email
     */
    support_email: string;

    /**
     * Activation email
     */
    activation_email: string;

    /**
     * Activation email type
     */
    activation_email_type: string;

    /**
     * Email Template
     */
    email_template: string;

    /**
     * Custom domain name
     */
    custom_domain_name: string;

    /**
     * Header Logo
     */
    header_logo: string;

    /**
     * Banner Logo
     */
    banner_logo: string;

    /**
     * Header logo attachment id
     */
    header_logo_attachment_id: string;

    /**
     * Header logo attachment id
     */
    banner_logo_attachment_id: string;

    /**
     * Footer text
     */
    footer_text: string;

    /**
     * Type of template
     */
    template_type: string;

    /**
     * Email settings
     */
    email_settings: models.MasterAccountEmailSetting;

    /**
     * To Address
     */
    to_address: string;

    /**
     * Subject
     */
    subject: string;

    /**
     * Message
     */
    message: string;

    /**
     * User Guide URL
     */
    user_guide_url: string;

    /**
     * Support URL
     */
    support_url: string;

    /**
     * Terms and Conditions URL
     */
    terms_and_conditions_url: string;

    /**
     * Integrated Tool for support system
     */
    support_tool_account_id: string;

}
